import { useAlgoliaSearchStore } from '@/stores/Category/AlgoliaSearchStore';
import { AlgoliaCategory } from '@/types/Algolia/AlgoliaCategory';
import { AlgoliaHit } from '@/types/Algolia/AlgoliaHit';
import { useSessionStorage } from '@vueuse/core';
import { type SearchResponse } from 'algoliasearch';
import { defineStore } from 'pinia';
import { type Ref, ref } from 'vue';

export const useAlgoliaCategoryStore = defineStore(
  `algolia-category-${window.store_code}`,
  () => {
    const searchStore = useAlgoliaSearchStore();

    const categoryIndex = window.category_index;

    const numberOfFacetValuesToDisplay = 7;
    const maximumNumberOfFacetValuesToDisplay = 100;
    const numberOfCategoriesToDisplayOnDesktop = 9;
    const numberOfCategoriesToDisplayOnMobile = 12;

    const numberOfProductAutocompleteResults = 6;
    const numberOfCategoryAutocompleteResults = 3;

    // Persist category results to session storage
    const categoryMap: Ref<Record<string, SearchResponse<AlgoliaHit>[]>> =
      useSessionStorage('algolia-category-map', ref({}));

    async function getCategories(): Promise<AlgoliaCategory[]> {
      if (!categoryMap.value[categoryIndex]) {
        console.debug('No cached categories found, fetching from Algolia');

        const response = await searchStore
          .getAlgoliaClient()
          .searchForHits<AlgoliaHit>({
            requests: [{ indexName: categoryIndex, hitsPerPage: 500 }],
          });

        if (!response.results.length) {
          return [];
        }

        categoryMap.value[categoryIndex] = response.results;
      }

      return categoryMap.value[categoryIndex].flatMap(r =>
        r.hits.map(hit => ({
          id: hit.objectID,
          name: hit.name,
          imageUrl: hit.image_url,
        }))
      );
    }

    return {
      categoryIndex,
      numberOfProductAutocompleteResults,
      numberOfCategoryAutocompleteResults,
      getCategories,
      numberOfFacetValuesToDisplay,
      maximumNumberOfFacetValuesToDisplay,
      numberOfCategoriesToDisplayOnDesktop,
      numberOfCategoriesToDisplayOnMobile,
    };
  }
);
